<div class="container">
  <h1 class="mb-4">
    About Aqaix
  </h1>
  <div>
    Aqaix is an Impact Fintech, Digitizing Water Finance.
    All Fintechs use data to contextualize financial decisions and automate finance business processes.
    Aqaix uses data and modern software to make water infrastructure investing faster, safer, and more profitable.
    The Aqaix water finance marketplace is architected using REST APIs internally, and using REST APIs to integrate data from myriad sources.
  </div>
</div>
